/**
 * Auto-generated service - DO NOT EDIT MANUALLY
 * Generated from: team.ts
 * Run: pnpm gen
 */

import { API_METHODS } from '../constants/api-methods';
import { getApiPath } from '../path';
import { type RequestOptions, type Transport } from '../transport';

import type {
  CreateTeamRequest,
  CreateTeamResponse,
  DeleteTeamRequest,
  DeleteTeamResponse,
  GetCurrentUserTeamsRequest,
  GetCurrentUserTeamsResponse,
  GetTeamRequest,
  GetTeamResponse,
  ListTeamsRequest,
  ListTeamsResponse,
  UpdateTeamRequest,
  UpdateTeamResponse,
} from '../types/team';

export const createTeamService = (transport: Transport) => ({
  async createTeam(
    request: CreateTeamRequest,
    options: RequestOptions = {},
  ): Promise<CreateTeamResponse> {
    const url = getApiPath(API_METHODS.TeamService.CreateTeam);
    return transport.post<CreateTeamResponse>(url, request, options);
  },

  async getTeam(request: GetTeamRequest, options: RequestOptions = {}): Promise<GetTeamResponse> {
    const { team_id } = request;
    const url = getApiPath(API_METHODS.TeamService.GetTeam, { team_id });
    return transport.get<GetTeamResponse>(url, options);
  },

  async listTeams(
    request: ListTeamsRequest,
    options: RequestOptions = {},
  ): Promise<ListTeamsResponse> {
    const url = getApiPath(API_METHODS.TeamService.ListTeams);
    return transport.get<ListTeamsResponse>(url, { params: request, ...options });
  },

  async getCurrentUserTeams(
    request: GetCurrentUserTeamsRequest,
    options: RequestOptions = {},
  ): Promise<GetCurrentUserTeamsResponse> {
    const url = getApiPath(API_METHODS.TeamService.GetCurrentUserTeams);
    return transport.get<GetCurrentUserTeamsResponse>(url, { params: request, ...options });
  },

  async updateTeam(
    request: UpdateTeamRequest,
    options: RequestOptions = {},
  ): Promise<UpdateTeamResponse> {
    const { team_id, ...body } = request;
    const url = getApiPath(API_METHODS.TeamService.UpdateTeam, { team_id });
    return transport.post<UpdateTeamResponse>(url, body, options);
  },

  async deleteTeam(
    request: DeleteTeamRequest,
    options: RequestOptions = {},
  ): Promise<DeleteTeamResponse> {
    const { team_id } = request;
    const url = getApiPath(API_METHODS.TeamService.DeleteTeam, { team_id });
    return transport.delete<DeleteTeamResponse>(url, options);
  },
});

export type TeamService = ReturnType<typeof createTeamService>;
